import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=5a9a0faa&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a9a0faa')) {
      api.createRecord('5a9a0faa', component.options)
    } else {
      api.reload('5a9a0faa', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=5a9a0faa&", function () {
      api.rerender('5a9a0faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26K0aBrqqIhnN/JS/offershelp.vue"
export default component.exports